import { render, staticRenderFns } from "./PortalFavoriteMenusPanel.vue?vue&type=template&id=087ac82f&scoped=true&"
import script from "./PortalFavoriteMenusPanel.vue?vue&type=script&lang=ts&"
export * from "./PortalFavoriteMenusPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PortalFavoriteMenusPanel.vue?vue&type=style&index=0&id=087ac82f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ac82f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VDivider,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})
